export const validUSPhoneNumberRegex =
  /^\+1 \([2-9][0-9]{2}\) [0-9]{3}-[0-9]{4}$/;
